import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderBulkClear,
  IInventoryPurchaseOrderBulkClearResponse,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useInventoryPurchaseOrderBulkClearAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (data: IInventoryPurchaseOrderBulkClear) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .post(`${INVENTORY_MODULE?.PURCHASE_ORDER_BULK_CLEAR?.baseURL}`, data, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderBulkClearResponse>) => {
            if (res.status == 200) {
              toast.success("Bulk clear successfully ");
              return { status: true, message: "Cleared" };
            } else {
              toast.error("Bulk clear failed ");
              return { status: false, message: "Failed" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            const vv = e.response.data as any;
            captureError(e);
            return { status: false, message: vv.message };
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;
        toast.error("Server Error: " + e.message);
        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return execute;
};
